var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import log from 'loglevel';

export default function withStateFrom(stateSource$, BaseComponent) {
    var withStateForm = function (_Component) {
        _inherits(withStateForm, _Component);

        function withStateForm() {
            _classCallCheck(this, withStateForm);

            return _possibleConstructorReturn(this, (withStateForm.__proto__ || Object.getPrototypeOf(withStateForm)).apply(this, arguments));
        }

        _createClass(withStateForm, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                this.disposable = stateSource$.subscribe(function (state) {
                    return _this2.setState(state);
                }, function (error) {
                    return log.error(error);
                });
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.disposable && this.disposable.unsubscribe && this.disposable.unsubscribe();
            }
        }, {
            key: 'render',
            value: function render() {
                return React.createElement(BaseComponent, _extends({}, this.state, this.props));
            }
        }]);

        return withStateForm;
    }(Component);

    withStateForm.displayName = BaseComponent.displayName || BaseComponent.name;

    return withStateForm;
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/component-helpers/withStateFrom.js
// module id = 102
// module chunks = 0